<span
  class="vault-spinner"
  [style.width.px]="sizePx"
  [style.height.px]="sizePx"
  [style.border-width.px]="strokeWidthPx"
  [style.border-color]="trackColor"
  [style.border-top-color]="accentColor"
  aria-hidden="true">
</span>
